import styled from 'styled-components';
import {Colors} from '../../../utils/style/colors';

export const DiffList = styled.div`
  margin-bottom: 16px;

  .diff-row {
    padding: 6px 0;
    gap: 8px;
    border-bottom: 1px solid ${Colors.gray20};
  }
  .diff-from {
    max-width: 35%;
    color: ${Colors.gray50};
    text-decoration: line-through;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .diff-arrow {
    color: ${Colors.gray40};
  }
  .diff-to {
    max-width: 35%;
    font-weight: 600;
    color: ${Colors.primary()};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ListWrapper = styled.div`
  
  ul > div {
    padding: 0;
  }
  hr {
    margin: 0 3px !important;
  }
  
`;

export const Scroll = styled.div`
  max-height: 250px;
  overflow: auto;
  
 > div {
    padding: 0;
 }
`;